import { IAppTrackerConfig } from "../../main";

export const setAppConfigOnWindowForTrackers = (appConfig: IAppTrackerConfig) => {
  const { getNRAccountId, getNRAgentId, getNRLicenseKey, getPendoApiKey } = appConfig;

  window.appTrackerConfig = { getNRAccountId, getNRAgentId, getNRLicenseKey, getPendoApiKey };
};
